import { NotifyHelper } from "../../../helpers/toast";
import { edongBoCongNoActionsObj } from "../../action-types/dong-bo/IDongBoCongNoAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const dongBoCongNoActions = {
  ...generateActions(edongBoCongNoActionsObj, "DONG_BO_CONG_NO"),
  ...generateActionForKey(
    edongBoCongNoActionsObj,
    "DONG_BO_CONG_NO",
    "SYNC_SUCCESS",
    (m) => {
      NotifyHelper.Success("Đồng bộ thành công");
    }
  ),
  ...generateActionForKey(
    edongBoCongNoActionsObj,
    "DONG_BO_CONG_NO",
    "SYNC_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Đồng bộ thất bại");
    }
  ),
};
